import React from "react";
import FullRouter from "./RouterPath/index";
import "bootstrap/dist/css/bootstrap.min.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./App.css";
import "./Assets/style/style.css";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { PermissionProvider } from "./Context/PermissionContext";
import { GoogleOAuthProvider } from "@react-oauth/google";


const theme = createTheme();

function App() {
  return (
    <HelmetProvider>
      <GoogleOAuthProvider >
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <PermissionProvider>
                <FullRouter />
            </PermissionProvider>
          </BrowserRouter>
        </ThemeProvider>
      </GoogleOAuthProvider>
    </HelmetProvider>
  );
}

export default App;
